document.addEventListener("click", async function (event) {
  const button = event.target.closest("[data-hydre-copy-referral]");
  if (!button) return;

  const section = button.closest(".hydre-agora");
  const link = section && section.querySelector("[data-hydre-referral-link]");
  const value = link ? link.textContent.trim() : "";

  if (!value) return;

  try {
    await navigator.clipboard.writeText(value);
    const original = button.textContent;
    button.textContent = "Copié";
    window.setTimeout(function () {
      button.textContent = original;
    }, 2000);
  } catch (error) {
    button.textContent = "Copie impossible";
    window.setTimeout(function () {
      button.textContent = "Copier mon lien";
    }, 2000);
  }
});


// Hydre header menu start
document.addEventListener("click", function (event) {
  const toggle = event.target.closest("[data-hydre-menu-toggle]");
  const mobileLink = event.target.closest("[data-hydre-mobile-link]");
  const header = document.querySelector("[data-hydre-header]");

  if (!header) return;

  const panel = header.querySelector("[data-hydre-mobile-panel]");
  const button = header.querySelector("[data-hydre-menu-toggle]");

  function closeMenu() {
    header.classList.remove("is-open");
    document.body.classList.remove("hydre-menu-open");

    if (button) {
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-label", "Ouvrir le menu");
    }

    if (panel) {
      panel.setAttribute("aria-hidden", "true");
    }
  }

  function openMenu() {
    header.classList.add("is-open");
    document.body.classList.add("hydre-menu-open");

    if (button) {
      button.setAttribute("aria-expanded", "true");
      button.setAttribute("aria-label", "Fermer le menu");
    }

    if (panel) {
      panel.setAttribute("aria-hidden", "false");
    }
  }

  if (toggle) {
    if (header.classList.contains("is-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  if (mobileLink) {
    closeMenu();
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") return;

  const header = document.querySelector("[data-hydre-header]");
  if (!header || !header.classList.contains("is-open")) return;

  const panel = header.querySelector("[data-hydre-mobile-panel]");
  const button = header.querySelector("[data-hydre-menu-toggle]");

  header.classList.remove("is-open");
  document.body.classList.remove("hydre-menu-open");

  if (button) {
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", "Ouvrir le menu");
    button.focus();
  }

  if (panel) {
    panel.setAttribute("aria-hidden", "true");
  }
});
// Hydre header menu end


// Hydre ingredients interaction start
document.addEventListener("click", function (event) {
  const closeButton = event.target.closest("[data-hydre-ingredient-close]");
  if (closeButton) {
    const closeSection = closeButton.closest("[data-hydre-ingredients]");
    if (closeSection) {
      closeSection.classList.add("hydre-ingredients--detail-closed");
    }
    return;
  }

  const button = event.target.closest("[data-hydre-ingredient]");
  if (!button) return;

  const section = button.closest("[data-hydre-ingredients]");
  if (!section) return;

  section.classList.remove("hydre-ingredients--detail-closed");

  section.querySelectorAll("[data-hydre-ingredient]").forEach(function (node) {
    node.classList.remove("is-active");
    node.setAttribute("aria-pressed", "false");
  });

  button.classList.add("is-active");
  button.setAttribute("aria-pressed", "true");

  const fields = {
    key: section.querySelector("[data-hydre-ingredient-key]"),
    amount: section.querySelector("[data-hydre-ingredient-amount]"),
    name: section.querySelector("[data-hydre-ingredient-name]"),
    description: section.querySelector("[data-hydre-ingredient-description]"),
    source: section.querySelector("[data-hydre-ingredient-source]"),
    role: section.querySelector("[data-hydre-ingredient-role]")
  };

  if (fields.key) fields.key.textContent = button.dataset.key || "";
  if (fields.amount) fields.amount.textContent = button.dataset.amount ? `${button.dataset.amount} / comprimé` : "";
  if (fields.name) fields.name.textContent = button.dataset.name || "";
  if (fields.description) fields.description.textContent = button.dataset.description || "";
  if (fields.source) fields.source.textContent = button.dataset.source || "";
  if (fields.role) fields.role.textContent = button.dataset.role || "";
});
// Hydre ingredients interaction end


// Hydre comparison interaction start
document.addEventListener("click", function (event) {
  const button = event.target.closest("[data-hydre-comparison-tab]");
  if (!button) return;

  const section = button.closest("[data-hydre-comparison]");
  if (!section) return;

  const view = button.getAttribute("data-hydre-comparison-tab");
  const mobileTable = section.querySelector(".hydre-comparison__table--mobile");

  section.querySelectorAll("[data-hydre-comparison-tab]").forEach(function (tab) {
    const isActive = tab === button;
    tab.classList.toggle("is-active", isActive);
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
  });

  if (mobileTable && view) {
    mobileTable.setAttribute("data-view", view);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hydre-comparison__table--mobile").forEach(function (table) {
    if (!table.hasAttribute("data-view")) {
      table.setAttribute("data-view", "composition");
    }
  });
});
// Hydre comparison interaction end
